import { Breadcrumb, Layout, Menu, Modal, Row, Col, Button, Carousel, Upload, Card, Input, Tabs, Typography, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import './css/cramSchool.css';
import Carousel_news_ticker from './components/Carousel_news_ticker';
import ShareLearningModal from './components/ShareLearningModal';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
const { Title, Paragraph, Text, Link } = Typography;
const { Dragger } = Upload;
const { TextArea } = Input;
const { confirm } = Modal;

const CustomTabs = styled.div`
    .ant-tabs-tab{
        font-size :24px;
        font-weight: 700;
        border-radius: 10px;
        background-color: #F5F5F5;
    }
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active{
        font-size :30px;
        font-weight: 700;
        // background-color: #F5F5F5 !important;
        // border-radius: 20px;
    }
    .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab{
      padding:15px;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
    //   color:#FFFFFF; 
    }
    .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab{
    //   background:#FFF4C1;
      font-size :17px;
    }
    .ant-tabs-tab:hover {
        color: #bbb;
        background: #F5F5F5;
    }
    .ant-tabs-tab-btn:focus, .ant-tabs-tab-remove:focus, .ant-tabs-tab-btn:active, .ant-tabs-tab-remove:active {
        color: #F5F5F5;
    }
`;
const AdminShareLearning = () => {
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const [title, setTitle] = useState('新增');
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [permission, setPermission] = useState(true);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [activeKey, setActiveKey] = useState(0);
    const [tabedit, setTabEdit] = useState('');
    const [edit_tab_name, set_edit_tab_name] = useState('');
    const [data, setData] = useState([]);
    const [items, setItems] = useState([]);
    useEffect(() => {
        setItems(pre => {
            return Object.keys(data).map((value, key) => {
                return {
                    label: value,
                    key: key + 1,
                    children: (
                        <>
                            <Row gutter={[40, 16]} justify='center'>
                                {
                                    data && data[value] &&( data[value]?.learn_witness || []).map((item, index) => {
                                        return (
                                            <>
                                                <Col span={22} >
                                                    <Card
                                                        // bordered
                                                        style={{ position: 'relative', borderStyle: 'solid' }}
                                                    >
                                                        <Row gutter={16} justify="center">
                                                            <Col md={{ span: 12 }} sm={{ span: 24 }} >
                                                                <Carousel_news_ticker file_url={item['file_url']} height={'250px'} width={'auto'} />
                                                            </Col>
                                                            <Col sm={{ span: 24 }} md={{ span: 12 }} >
                                                                <Col style={{ padding: '5px' }}>
                                                                    {item.title}
                                                                </Col>
                                                                <Col>
                                                                    <Col style={{ height: '180px' }}>
                                                                        {item.content}
                                                                    </Col>
                                                                </Col>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                    {permission ? <>
                                                        <Row >
                                                            <Col style={{ position: 'absolute', right: '0%', top: '-5%', }}>
                                                                <Button shape="circle" icon={<EditOutlined />} style={{ backgroundColor: '#F9D4E5' }} onClick={e => handleOnEdit(index)} />
                                                            </Col>
                                                        </Row>
                                                    </> : <></>}
                                                </Col>
                                            </>
                                        )
                                    })
                                }
                            </Row>
                        </>
                    )
                }
            })
        })
    }, [data])

    const get_tab = () => {
        axios
            .get('/cramSchool/api/learn_witness')
            .then((response) => {
                setData(response.data);
                get_picture(response.data);
            })
    }
    const get_picture = (data_tmp) => {
        Object.keys(data_tmp).forEach((value, key) => {
            if (data_tmp[value].learn_witness.length != 0) {
                data_tmp[value].learn_witness.map((temp, index) => {
                    let learn_witness_id = temp['learn_witness_id'];
                    if (temp['file_id'].length != 0) {
                        temp.file_id.map((tmp, key) => {
                            axios
                                .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                                .then((response) => {
                                    var blob_ = new Blob([response.data], {
                                        type: "image/jpg",// this is the only MIME for SVG
                                    });
                                    const dataurl = URL.createObjectURL(blob_);
                                    setData(
                                        (pre) => {
                                            // console.log(pre,value)
                                            return ({
                                                ...pre,
                                                [value]: {
                                                    ...pre[value],
                                                    learn_witness: pre[value]['learn_witness'].map((value, index) => {
                                                        if (learn_witness_id == value.learn_witness_id) {
                                                            if (value.file_url != undefined) {
                                                                return (
                                                                    {
                                                                        ...value,
                                                                        file_url: [...value.file_url, dataurl]
                                                                    }
                                                                )
                                                            } else {
                                                                return (
                                                                    {
                                                                        ...value,
                                                                        file_url: [dataurl]
                                                                    }
                                                                )
                                                            }
                                                        } else {
                                                            return (
                                                                { ...value }
                                                            )

                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    )
                                })
                        })
                    }
                })
            }
        })
    }

    useEffect(() => {
        get_tab();
    }, [])

    const newTabIndex = useRef(1);
    const onChange = (newActiveKey) => {
        setActiveKey(newActiveKey);
    };
    // const [data, setData] = useState([]);
    const add = () => {
        const newActiveKey = `新分類${newTabIndex.current++}`;
        const newPanes = [...items];
        newPanes.push({
            label: newActiveKey,
            children: '',
            key: newActiveKey,
        });
        axios
            .post('/cramSchool/api/learn_witness/type', [{ "name": newActiveKey }])
            .then((response) => {
                if (response.data.status == 'success') {
                    // setItems(newPanes);
                    // setActiveKey(newActiveKey);
                    get_tab();
                } else {
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗',
                    });
                }
            })
    };

    useEffect(() => {
        setActiveKey(items[0])
    }, [])

    const remove = (targetKey) => {
        // let newActiveKey = activeKey;
        // console.log(newActiveKey)
        const newPanes = items.filter((item) => item.key == targetKey);
        let id = ''
        id = data[newPanes[0]['label']].learn_witness_type_id;
        // console.log(id);
        const deleterow = [{ "learn_witness_type_id": id }];
        axios
            .delete('/cramSchool/api/learn_witness/type', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_tab();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_tab();
                }
            })
    };

    const onEdit = (targetKey, action) => {
        if (action === 'add') {
            add();
        } else {
            showConfirm(targetKey);
            // remove(targetKey);
        }
    };

    const handleOnEdit = (value, id) => {
        setTitle('修改');
        setColor('f09a45');
        setEdit(true);
        data[value].learn_witness.map((item, index) => {
            if (item.learn_witness_id == id) {
                setEditCard({ ...item, "learn_witness_type_name": value, "learn_witness_type_id": data[value].learn_witness_type_id });
            }
        })
        setOpen(true)
    }

    const handleOnEditTab = () => {
        axios
            .patch('/cramSchool/api/learn_witness/type', [{ "learn_witness_type_id": tabedit, "name": edit_tab_name }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_tab();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_tab();
                }
                setTabEdit('');
                set_edit_tab_name('');
            })
    }

    const handleEdit = (file_id) => {
        setOpen(false);
        // let data_tmp = [{ ...editcard }];
        if (editcard['file_id'] == "{0}") {
            editcard['file_id'] = null;
        }
        // console.log(editcard); 
        axios
            .patch(`/cramSchool/api/learn_witness`, [{ ...editcard, file_id }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_tab();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_tab();
                }
            })
    }

    const handleSubmit = (file_id) => {
        // console.log(editcard);
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            axios
                .post(`/cramSchool/api/learn_witness`, [{ ...editcard, file_id }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        get_tab();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        get_tab();
                    }
                })
        }
        // console.log(editcard); 
    }

    const handleDelete = (id) => {
        const deleterow = [{ "learn_witness_id": id }];
        axios
            .delete('/cramSchool/api/learn_witness', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_tab();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_tab();
                }
            })

    }
    const showConfirm = (targetKey) => {
        confirm({
            title: '確認刪除此標籤嗎？',
            icon: <ExclamationCircleFilled />,
            onOk() {
                remove(targetKey)
            },
        });
    };
    return (
        <>
            <CustomTabs>
                {contextHolder}
                <ShareLearningModal
                    open={open}
                    edit={edit}
                    title={title}
                    color={color}
                    // setData={setData}
                    // data={data}
                    editcard={editcard}
                    setEditCard={setEditCard}
                    setOpen={setOpen}
                    handleEdit={handleEdit}
                    handleSubmit={handleSubmit}
                    handleDelete={handleDelete}
                    destroyOnClose
                />
                <Row gutter={[40, 16]} style={{ paddingTop: '10px', paddingBottom: '30px' }}>
                    {permission ? <>
                        <Col span={24}>
                            <Row justify="end" >
                                <Col>
                                    <Button className='example' style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle('新增'); setEditCard({}); setEdit(false); setOpen(true) }}
                                        icon={<PlusOutlined />}
                                    >新增學習見證</Button>
                                </Col>
                            </Row>
                        </Col>
                    </> : <></>}
                    <Col span={24}>
                        <Tabs
                            tabBarStyle={{
                                border: 'hidden'
                            }}
                            type={permission ? "editable-card" : "card"}
                            onChange={onChange}
                            activeKey={activeKey}
                            onEdit={onEdit}
                            items={
                                data && Object.keys(data).map((value, key) => {
                                    return {
                                        label: (
                                            <>
                                                <Col span={24}>
                                                    <Row gutter={16} align="bottom">
                                                        {tabedit == `${data[value].learn_witness_type_id}` ?
                                                            <>
                                                                <Col >
                                                                    <Input defaultValue={value} onChange={(e) => set_edit_tab_name(e.target.value)}></Input>
                                                                </Col>
                                                                <Col>
                                                                    <Button className='example' type="primary" onClick={handleOnEditTab}>完成</Button>
                                                                </Col>
                                                            </> : <>
                                                                <Col>
                                                                    <EditOutlined
                                                                        className='example'
                                                                        style={{
                                                                            backgroundColor: '#F9D4E5',
                                                                            fontSize: '1.2rem',
                                                                            borderRadius: '50%',
                                                                            padding: '8px'
                                                                        }}
                                                                        onClick={(e) => { setTabEdit(data[value].learn_witness_type_id); set_edit_tab_name(value); }}
                                                                    />
                                                                    <span onDoubleClick={(e) => { setTabEdit(data[value].learn_witness_type_id); set_edit_tab_name(value); }}>{value}</span>
                                                                </Col>
                                                            </>}
                                                    </Row>
                                                </Col>
                                            </>
                                        )
                                        ,
                                        key: key + 1,
                                        children: (
                                            <>
                                                <Row gutter={[40, 16]} justify='center'>
                                                    {
                                                        data && data[value]&& (data[value]?.learn_witness ||[]).map((item, index) => {
                                                            return (
                                                                <>
                                                                    <Col span={22} >
                                                                        <Card
                                                                            // bordered
                                                                            style={{ position: 'relative', borderStyle: 'solid', alignItems: 'center' }}
                                                                            hoverable
                                                                            onClick={e => navigate(`/cramSchool/ShareLearning/${item['learn_witness_id']}`)}
                                                                        >
                                                                            <Row gutter={[24, 8]} >
                                                                                <Col md={{ span: 12 }} sm={{ span: 24 }} >
                                                                                    <Carousel_news_ticker file_url={item['file_url']} height={'250px'} width={'auto'} />
                                                                                </Col>
                                                                                <Col sm={{ span: 24 }} md={{ span: 12 }} >
                                                                                    <Col style={{ padding: '5px' }}>
                                                                                        {item.title}
                                                                                    </Col>
                                                                                    <Col>
                                                                                        <Col style={{ height: '180px' }}>
                                                                                            {item.content}
                                                                                        </Col>
                                                                                    </Col>
                                                                                </Col>
                                                                            </Row>
                                                                        </Card>
                                                                        {permission ? <>
                                                                            <Row >
                                                                                <Col style={{ position: 'absolute', right: '0%', top: '-5%', }}>
                                                                                    <EditOutlined
                                                                                        className='example'
                                                                                        style={{
                                                                                            backgroundColor: '#F9D4E5',
                                                                                            fontSize: '1.2rem',
                                                                                            borderRadius: '50%',
                                                                                            padding: '8px'
                                                                                        }}
                                                                                        onClick={e => handleOnEdit(value, item.learn_witness_id)}
                                                                                    />
                                                                                </Col>
                                                                            </Row>
                                                                        </> : <></>}
                                                                    </Col>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </>
                                        )
                                    }
                                })
                            }
                        // items={items}
                        />
                    </Col>
                </Row >
            </CustomTabs >
        </>
    );
};

export default AdminShareLearning;